import userAgent from '@storyverseco/user-agent';
import { isReactSnap } from '../config/consts';

export enum OS {
  Android = ' Android',
  iOS = ' iOS',
  Windows = ' Windows',
  Unknown = ' Unknown',
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows', or 'Unknown'.
 */
export function getMobileOS() {
  //@ts-ignore
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return OS.Windows;
  }

  if (/android/i.test(userAgent)) {
    return OS.Android;
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  //@ts-ignore
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return OS.iOS;
  }

  return OS.Unknown;
}

export function isMobile() {
  return userAgent.isMobile;
}

export function isAndroid() {
  return userAgent.os.isAndroid;
}

export function isIOS() {
  return userAgent.os.isIOS;
}

export function isDesktop() {
  return !userAgent.isMobile;
}

// ---------------------------------------------------------------------
// The above does not work for me when checking on chrome emulator modes

export function isMobileEmulated() {
  return window.navigator.userAgent.indexOf('Mobile') !== -1 || isReactSnap;
}

export function isMobileEmulatedByBrowser() {
  return isMobileEmulated() && navigator.maxTouchPoints == 1;
}

export function getDeviceMode(): 'desktop' | 'mobile' {
  if (isMobileEmulated()) return 'mobile'; // this works for both chrome and xcode emulators
  if (isMobile()) return 'mobile'; // this only works for real devices

  return 'desktop';
}
